import type { DocumentFont } from '@flobi/artwork-core';

/** Renderer aliases stay in the document; only the human-facing label is shortened. */
export function fontName(family: string, fonts: readonly DocumentFont[]): string {
  const font = fonts.find(item => item.family === family);
  if (font?.source !== 'upload' || !font.assetId || !/ [a-f0-9]{8}$/i.test(family)) return family;
  return family.replace(/ [a-f0-9]{8}$/i, '').replace(/ (?:thin|extra light|extralight|light|regular|normal|medium|semi ?bold|demi ?bold|extra ?bold|ultra ?bold|bold|black|heavy)(?: italic| oblique)?$| (?:italic|oblique)$/i, '');
}
